<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="content-1">
        <section class="body">
          <div>
            <div>
              <div v-if="arePurchasesLoading">
                <div class="content">
                  <div class="centered-row">
                    <div class="loading">
                      <Fai :icon="['far', 'circle-notch']" spin/>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="arePurchasesFinishedLoadingSuccessfully">
                <div v-if="arePurchasesEmpty">
                  <div class="content">
                    <div class="text-1">
                      <span>It appears you have not made any purchases.</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="purchases">
                    <div v-for="(datum, i) in allPurchases" :key="i">
                      <div @click="onPurchaseClick(datum.purchase.study.id)">
                        <router-link :to="datum.route">
                          <div class="purchase">
                            <div class="row align-center">
                              <div class="row align-center left">
                                <div class="name">

                                    <h4>
                                      <span v-if="datum.purchase.study.name">{{datum.purchase.study.name}}</span>
                                      <span v-else>Unnamed Study</span>
                                    </h4>

                                </div>
                              </div>
                            </div>
                            <div class="tags">
                              <small>
                                  <span v-for="(tag, j) in datum.derived.tagsWithCommas" :key="j">
                                    {{tag}}
                                  </span>
                              </small>
                            </div>
                            <div class="study-creation">
                              <span>Created: {{datum.derived.dateCreated}}</span>
                            </div>
                            <div class="study-creation">
                              <span>Type: {{datum.purchase.type}}</span>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="arePurchasesInAFailedState">
                <div class="text-1">
                  <h5>
                    {{purchasesError}}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_PURCHASES_OF_USER,
    GET_STUDY,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED,
    R_NAME_FLASH_RESULTS,
    R_NAME_RESULTS,
    RESET_SELECTED_QUALIFICATIONS
  } from "../../services/constants"
  import {mapGetters} from "vuex"

  export default {
        name: "MyPurchases",

      created() {

      },

      data(){
        return{

        }
      },

      computed: {
        ...mapGetters([
          GET_PURCHASES_OF_USER
        ]),
        allPurchases(){
          return this[GET_PURCHASES_OF_USER].map(datum => {
            datum.derived.tagsWithCommas = datum.derived.tags.map((tag, i, tags) => {
              return i !== tags.length - 1 ? `${tag},` : tag
            })
            return datum
          })
          // })
        },
        arePurchasesLoading() {
          return this.purchasesState.loadingState === LOADING_STARTED
        },
        arePurchasesFinishedLoadingSuccessfully() {
          return this.purchasesState.loadingState === LOADING_COMPLETED_SUCCESS
        },
        arePurchasesInAFailedState() {
          return this.purchasesState.loadingState === LOADING_COMPLETED_FAILURE
        },
        purchasesError() {
          // return this.studiesState.error.message
          return 'Loading purchases failed'
        },
        arePurchasesEmpty() {
          return this.allPurchases.length === 0
        },
        purchasesState() {
          return this.$store.state.dataModule.purchases
        },
      },

      methods: {
        onPurchaseClick(id) {
          this.$store.dispatch(GET_STUDY, id).then(()=>{
            return this.$store.dispatch(RESET_SELECTED_QUALIFICATIONS)
          })
        },
      },
    }

</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .content-1 {
    margin: 0 60px;
  }

  .header{
    padding-bottom: 30px;
    color: $red-2;
    font-weight: bolder;
    font-size: 20px;
  }

  section.body {
    .content {
      padding: 2em 0;
    }
  }

  .purchases {
    padding: 1em 0 5em 0;
    a {
      color: $cyan-1;
      text-decoration: none;
    }
  }

  .purchase {
    border-bottom: 1px solid $red-2;
    padding: 30px 0;

    .name {
      color: $cyan-blue-3;
      font-size: 17px;

      h5 {
        margin: 1em 0;
      }
    }

    .left {
      flex-grow: 1;
    }

    .tags {
      color: $gray-3;
    }

    .study-creation {
      font-weight: 300;
      font-size: 15px;
      color: $cyan-1;
      padding: 5px 0 0 0;
    }

    .view-count {
    }
  }

</style>
